import { Link } from "react-router-dom";
import { navItems } from "@/mocks/nav";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide">
                嘿咻嘿咻漫画资讯站
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/90">
              专注嘿咻嘿咻漫画的剧情速览、结局考据、角色档案与读者讨论，帮你快速理清故事脉络，追更不迷路。用温柔的日常，讲动人的成长。
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="https://weibo.com"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="Twitter"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
              <a
                href="https://bilibili.com"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50">
              栏目导航
            </h4>
            <ul className="mt-4 space-y-3">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="inline-flex items-center gap-2 text-sm text-background-200/90 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-primary-300"></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50">
              热门栏目
            </h4>
            <ul className="mt-4 space-y-3">
              <li><Link to="/plot" className="text-sm text-background-200/90 transition-colors hover:text-background-50">结局深度解析</Link></li>
              <li><Link to="/characters" className="text-sm text-background-200/90 transition-colors hover:text-background-50">角色设定档案</Link></li>
              <li><Link to="/reviews" className="text-sm text-background-200/90 transition-colors hover:text-background-50">读者评价讨论</Link></li>
              <li><Link to="/faq" className="text-sm text-background-200/90 transition-colors hover:text-background-50">常见问题解答</Link></li>
              <li><Link to="/about" className="text-sm text-background-200/90 transition-colors hover:text-background-50">关于我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-100/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/70">
            © {year} 嘿咻嘿咻漫画资讯站 · 内容仅供参考与讨论
          </p>
          <p className="text-xs text-background-200/70">
            尊重原创 · 理性追更 · 欢迎分享你的解读
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;